import React from 'react';
import { CSSTransition } from 'react-transition-group';

type SlideOutProps = {
  in?: boolean;
  children: JSX.Element;
  duration: number;
};

const SlideOut: React.FC<SlideOutProps> = ({
  in: inProp,
  children,
  duration,
}) => {
  const onEnter = (node: HTMLElement): void => {
    node.removeAttribute('style');
  };
  const onExiting = (node: HTMLElement): void => {
    node.style.transition = `height ${duration}ms ease-in-out`;
    node.style.opacity = '0';
    node.style.height = '0';
  };
  return (
    <CSSTransition
      in={inProp}
      timeout={duration}
      classNames="slide-out"
      unmountOnExit
      onEnter={onEnter}
      onExiting={onExiting}>
      {React.cloneElement(children, {
        ...children.props,
        style: {
          opacity: '1',
        },
      })}
    </CSSTransition>
  );
};

export default SlideOut;
